import React from "react";

import images from "../../../../utils/images";

const DownloadBtn = (props) => {
  const { url } = props;

  return (
    <a href={url}>
      <button className="DownloadBtn" href={url} target="_blank" type="button">
        <img
          alt="download btn icon"
          className="mr-2"
          src={images("./icons/download-icon-pri.svg")}
        />
        <span>Download</span>
      </button>
    </a>
  );
};

export default DownloadBtn;
